import React, { useEffect, useState } from "react";
import { NavigationButton, PrimaryButton } from "../../../Buttons";
import Label from "../../../Label";
import FormInputField from "../../../FormInputField";
import DateSelector from "../../../DateSelector";
import RadioButton from "../../../RadioButton";
import { useDispatch } from "react-redux";
import { getCompanyTypes } from "../../../../redux/actions/lookups/CompanyTypes";
import CompanyTypesSkeleton from "../../../Skeleton/CompanyTypesSkeletons";
import useSocCodes from "../../../../hooks/useSocCodes";
import useNaicsCodes from "../../../../hooks/useNaicsCodes";
import SearchableCodeInput from "../../../SearchableCodeInput";

const CompanyInformation = ({ handleNext, handlePrev, formData, onChange, setError }) => {
  const [preferenceOptions, setPreferenceOptions] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCompanyTypes = async () => {
      try {
        const res = await dispatch(getCompanyTypes());
        setPreferenceOptions(res);
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    if (preferenceOptions.length === 0) {
      fetchCompanyTypes();
    }
  }, [dispatch, preferenceOptions.length]);

  const isFormValid = () => {
    return (
      // formData.name &&
      formData.company_place &&
      formData.registration_date &&
      formData.business_reg_number &&
      formData.expiry_date &&
      formData.business_reg_address &&
      formData.nature_of_business &&
      formData.company_type &&
      formData.tax_number &&
      formData.company_city &&
      formData.soc_code &&
      formData.naics_code
    );
  };

  const socCodes = useSocCodes();
  const naicsCodes = useNaicsCodes();

  const [selectedSoc, setSelectedSoc] = useState(null);
  const [selectedNaics, setSelectedNaics] = useState(null);

  useEffect(() => {
    if (formData.soc_code && socCodes.length > 0) {
      const found = socCodes.find(
        (item) => item.soc_code === formData.soc_code,
      );
      if (found) setSelectedSoc(found);
    }

    if (formData.naics_code && naicsCodes.length > 0) {
      const found = naicsCodes.find(
        (item) => item.naics_code === formData.naics_code,
      );
      if (found) setSelectedNaics(found);
    }
  }, [formData.soc_code, formData.naics_code, socCodes, naicsCodes]);

  const handleSocChange = (option) => {
    setSelectedSoc(option);
    onChange({ target: { name: "soc_code", value: option.soc_code } });
  };

  const handleNaicsChange = (option) => {
    setSelectedNaics(option);
    onChange({ target: { name: "naics_code", value: option.naics_code } });
  };

  return (
    <div className="space-y-4 w-full md:w-[750px]">
      <Label
        className="block text-sm font-bold text-text-primary mb-3"
        htmlFor="personal-info"
        text="Company Information"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* <FormInputField
          label="Company Name"
          name="name"
          id="name"
          type="text"
          placeholder="Enter company name"
          value={formData.name}
          onChange={onChange}
        /> */}

        <SearchableCodeInput
          label="Occupation code"
          placeholder="Search occupation"
          options={socCodes}
          selectedOption={selectedSoc}
          onChange={handleSocChange}
          codeKey="soc_code"
          titleKey="job_title"
        />
        <SearchableCodeInput
          label="Industry sector code"
          placeholder="Search industry"
          options={naicsCodes}
          selectedOption={selectedNaics}
          onChange={handleNaicsChange}
          codeKey="naics_code"
          titleKey="naics_title"
        />
        <FormInputField
          label="Place of Registration of Company"
          name="company_place"
          id="company_place"
          type="text"
          placeholder="Enter place of registration"
          value={formData.company_place}
          onChange={onChange}
        />
        <DateSelector
          text="Date of Incorporation"
          name="registration_date"
          id="registration_date"
          placeholder="Enter date of incorporation"
          selectedDate={formData.registration_date}
          onChange={onChange}
          setError={setError}
        />
        <FormInputField
          label="Company Registration Number"
          name="business_reg_number"
          id="business_reg_number"
          type="text"
          placeholder="Enter registration number"
          value={formData.business_reg_number}
          onChange={onChange}
        />
        <DateSelector
          text="License Expiry Date"
          name="expiry_date"
          id="expiry_date"
          placeholder="Enter license expiry date"
          selectedDate={formData.expiry_date}
          disableFutureDates={false}
          disablePastDates={true}
          onChange={onChange}
          setError={setError}
        />
        <FormInputField
          label="Business Registration Address"
          name="business_reg_address"
          id="business_reg_address"
          type="text"
          placeholder="Enter company address"
          value={formData.business_reg_address}
          onChange={onChange}
        />
        <FormInputField
          label="Nature of Business"
          name="nature_of_business"
          id="nature_of_business"
          type="text"
          placeholder="Enter nature of business"
          value={formData.nature_of_business}
          onChange={onChange}
        />
        <FormInputField
          label="Company City"
          name="company_city"
          id="company_city"
          type="text"
          placeholder="Enter your company city"
          value={formData.company_city}
          onChange={onChange}
        />
        <FormInputField
          label="Tax Number"
          name="tax_number"
          id="tax_number"
          type="text"
          placeholder="Enter tax number"
          value={formData.tax_number}
          onChange={onChange}
        />
        <div className="md:col-span-2">
          {preferenceOptions.length ? (
            <>
              <p className="text-text-primary font-semibold text-sm">
                Company type
              </p>
              <RadioButton
                name="company_type"
                preferenceOptions={preferenceOptions}
                onChange={onChange}
                value={parseInt(formData.company_type)}
                layout="column"
              />
            </>
          ) : (
            <CompanyTypesSkeleton />
          )}
        </div>
      </div>
      <hr className="border border-divider" />
      <div className="flex md:w-96 w-full space-x-3">
        <NavigationButton onClick={handlePrev} text="Back" />
        <PrimaryButton
          disabled={!isFormValid()}
          onClick={handleNext}
          text="Continue"
        />
      </div>
    </div>
  );
};

export default CompanyInformation;
